import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, GroupItem, Grouping, Paging, Pager } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaCreacionLibre } from "../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { function_STK_ART_Stock_ListarConArticulosSinStock, function_STK_ART_Stock_ModificacionPorAjusteDeInventario } from "neftis7_apicaller/src/funciones/STK/STK_ART_Stock";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";

export const STK_ART_Stock_AjusteDeInventario = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const { Varios: { ObtieneParametros,
    TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { STK_ART_Stock: { function_STK_ART_Stock_Listar } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {

      const resultData = await function_STK_ART_Stock_ListarConArticulosSinStock();

      setData(resultData.data.map(item => ({
        ...item,
        CantidadReal: item.CantidadActual
      })));

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const getDataParametros = async () => {// Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    getDataParametros();

    getData()
  }, []);

  const handleOnClick_AjustarStock = async () => {
    const confirmacion = window.confirm("¿Está seguro que desea generar un Ajuste de Inventario?. El mismo se realizará para todos los items en los que CANTIDAD REAL tenga un valor y este sea diferente a CANTIDAD ACTUAL.");
                        if (!confirmacion) return;

    const JSON = data
      .filter(row =>
        row.CantidadReal != null &&
        row.CantidadReal !== row.CantidadActual 
      )
      .map(row => ({
        CodigoArticulo: row.CodigoArticulo,
        CodigoPresentacion: row.CodigoPresentacion,
        CodigoTamano: row.CodigoTamano,
        CodigoUnidadMedida: row.CodigoUnidadMedida,
        CodigoUbicacion: row.CodigoUbicacion,
        CantidadReal: row.CantidadReal,
        Fecha: FormateoFechaPara_yyyyMMdd(new Date()),
        Cantidad: row.CantidadReal, 
        Motivo: "AJUSTE DE INVENTARIO",
        CodigoCompania: localStorage.getItem("CodigoCompania"),
        CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
        CodigoPlanta: localStorage.getItem("CodigoPlanta")
      }));

    if (JSON.length === 0) {
      alert("No hay Ajustes de Inventario para guardar.");
      return;
    }

    try {      
      const resultAjustes = await function_STK_ART_Stock_ModificacionPorAjusteDeInventario(JSON);
      
      alert(resultAjustes.data.mensaje.replace("Creación exitosa del Código ", "Ajuste de Inventario creado con el/los Item/s Nº "));

      window.location.reload();
    } catch (error) {
      alert("Error al guardar el Ajuste de Inventario: " + error.message);
    }
  };

  return (
    <PaginaCreacionLibre
      Titulo="STOCK - AJUSTE DE INVENTARIO"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">

          <table >
            <tbody>
              <tr>

              </tr>
            </tbody>
          </table>
          <div className="table-responsive" style={{ gap: "10px" }}>
            {data.length > 0 ? (
              <>
                <LVButtonAccion Texto={"CREAR AJUSTE DE INVENTARIO"} onClick={handleOnClick_AjustarStock} />

                <LVGridCarga
                  dataSource={data}
                  id="gridContainer"
                  keyExpr={["CodigoArticulo", "CodigoPresentacion", "CodigoTamano", "CodigoUnidadMedida", "CodigoUbicacion"]}
                  allowDeleting={false}
                  filterRow={true}
                >
                  <Grouping autoExpandAll={true} />
                  <Summary>
                    <TotalItem
                      column="CodigoArticulo"
                      summaryType="count"
                      customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                    <GroupItem
                      column="CantidadActual"
                      summaryType="sum"
                      customizeText={summaryItem => `${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                      valueFormat="number"
                      showInGroupFooter={true} />
                  </Summary>

                  <Column caption="Artículo" alignment="Center">
                    <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Articulo" width="100%" minWidth={200} alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
                    <Column caption="Código" dataField="CodigoPresentacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                    <Column caption="Descripción" dataField="Presentacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                  </Column>
                  <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano} >
                    <Column caption="Código" dataField="CodigoTamano" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                    <Column caption="Descripción" dataField="Tamano" width="250" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                  </Column>

                  <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                    <Column caption="Código" dataField="CodigoUnidadMedida" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                    <Column caption="Descripción" dataField="UnidadMedida" width="250" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  </Column>
                  <Column caption="Ubicación" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                    <Column caption="Código" dataField="CodigoUbicacion" width="100" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                    <Column caption="Descripción" dataField="Ubicacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  </Column>
                  <Column caption="Cant. Actual" dataField="CantidadActual" width="130" alignment="Right" dataType="number" />
                  <Column
                    dataField="CantidadReal"
                    caption="Cant. Real"
                    width={130}
                    alignment="Right"
                    dataType="number"
                    allowEditing={true}
                    cellRender={(cellData) => (
                      <div className="dx-theme-accent-as-background-color" style={{
                        height: "100%",
                        padding: "4px",
                        fontWeight: "bold"
                      }}>
                        {cellData.value}
                      </div>
                    )}
                  />
                  <Paging defaultPageSize={12} />
                  <Pager
                    showPageSizeSelector={false}
                  />
                </LVGridCarga>
              </>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaCreacionLibre>
  );
};
